import { gql } from "@apollo/client"

export const GET_GEOFENCE_LIST_QUERY = gql`
    query GeofencesList($nextToken: ID, $limit: Int, $filter: FilterFindManyGeofenceInput) {
        geofencesList(nextToken: $nextToken, limit: $limit, filter: $filter) {
            nextToken
            records {
                _id
                properties {
                    name
                    entryNotifications
                    exitNotifications
                    speed
                }
                geometry
            }
        }
    }
`
